<template>
  <div>

    <router-view></router-view>

    <Timeline :steps="timelineSteps"></Timeline>

    <div class="notification center" v-if="this.$store.state.accomodationView && $store.state.accomodationView === 'images'">
      <p>Du visar nu våra boenden i ett specialläge där du kan ladda ner bilder.</p>
      <p><a href="#" @click.stop.prevent="goToNormal()">Gå till vanliga visningsläget</a></p>
    </div>

    <div>
      <div v-if="$store.state.cart.addToOrder && $store.state.cart.addToOrder.number">
        <h1 class="center">Tilläggsbokning</h1>
      </div>
      <div v-else>
        <h1 class="center">Boka din nästa semester</h1>
      </div>
    </div>

    <Note v-if="!SITE_CONFIG.modules_open.accomodation.fully_open" title="Bokningen för vintersäsongen 26/27 är öppen" color="blue">
      <p>Boenden släpps löpande fram till 1 juli.</p>
    </Note>

    <div class="notification notification--blue center cancellation-insurance-notice" v-if="cancellationInsuranceEnabled && SITE_CONFIG.accomodations.cancellation_insurance.text_list" v-html="SITE_CONFIG.accomodations.cancellation_insurance.text_list">
    </div>

    <Modal v-if="showModal()">
      <router-view></router-view>
    </Modal>

    <div :class="{'waiting-for-filter': isAwaitingFilter || loading}">
      <AccomodationsFilter :filterObject="filterObject"></AccomodationsFilter>
      <AccomodationsFilterInfo :unitCount="unitCount" :poolCount="poolCount" v-if="!loading"></AccomodationsFilterInfo>
    </div>
    <Loading :show="isAwaitingFilter" text="Filter tillämpas" />
    <AccomodationsList :pools="filteredPools" v-if="!loading" :locations="locations"></AccomodationsList>
    <Loading :show="loading" />

  </div>
</template>

<script>
import {
  flow,
  filter,
  some,
  sumBy,
} from 'lodash/fp';

import moment from 'moment';

import {
  filterUnit,
} from '@/lib';
import API from '@/classes/API';
import AccomodationsFilter from '@/components/parts/Accomodation/List/Filter/AccomodationsFilter';
import AccomodationsList from '@/components/parts/Accomodation/List/AccomodationsList';
import AccomodationsFilterInfo from '@/components/parts/Accomodation/List/Filter/AccomodationsFilterInfo';
import TextInput from '@/components/components/TextInput';
import Loading from '@/components/components/Loading';
import Note from '@/components/components/Note';

import Timeline from '@/components/components/Timeline';

import Modal from '@/components/components/Modal';

import accomodationTimelineSteps from '@/mixins/accomodationTimelineSteps';

import { mapGetters, mapMutations } from 'vuex';

const someUnit = predicate => pool => (
  pool && pool.units && some(predicate, pool.units)
);

const filterPools = (accomodationsFilter) => {
  const unitFilter = filterUnit(accomodationsFilter);
  return flow([
    filter(someUnit(unitFilter))]);
};

export default {
  components: {
    AccomodationsFilter,
    AccomodationsFilterInfo,
    AccomodationsList,
    Modal,
    Timeline,
    TextInput,
    Loading,
    Note,
  },
  mixins: [accomodationTimelineSteps],
  data() {
    return {
      filterObject: {},
      countTotal: 0,
      countMatches: 0,
      pools: [],
      loading: true,
      locations: [],
      cancellationInsuranceEnabled: false,
    };
  },
  beforeMount() {
    if (moment(this.$store.state.accomodationsFilter.date.startDate).isBefore(moment())) {
      console.log('Too early');
      this.$store.state.accomodationsFilter.date.startDate = null;
      this.$store.state.accomodationsFilter.date.endDate = null;
    }

    if (this.$store.state.cart.addToOrder && this.$store.state.cart.addToOrder.number) {
      this.$store.state.accomodationsFilter.date.startDate =
        this.$store.state.cart.addToOrder.dateStart;
      this.$store.state.accomodationsFilter.date.endDate =
        this.$store.state.cart.addToOrder.dateEnd;
    }

    if (this.$route.meta.view && this.$route.meta.view === 'images') {
      this.$store.state.accomodationView = 'images';
    }

    if (Object.keys(this.$route.query).length) {
      this.resetAccomodationsFilter();
    }

    if (this.$route.query.date1) {
      this.$store.state.accomodationsFilter.date.startDate = this.$route.query.date1;
    }
    if (this.$route.query.date2) {
      this.$store.state.accomodationsFilter.date.endDate = this.$route.query.date2;
    }
    if (this.$route.query.people) {
      this.$store.state.accomodationsFilter.beds = parseInt(this.$route.query.people, 10);
    }
    if (this.$route.query.area) {
      this.$store.state.accomodationsFilter.locationId = parseInt(this.$route.query.area, 10);
    }

    this.cancellationInsuranceEnabled =
      this.SITE_CONFIG.accomodations.cancellation_insurance.free;
  },
  async mounted() {
    this.increaseCurrentRequests();
    this.loading = true;
    const { meta, data } = await API.get('/grouped');
    this.decreaseCurrentRequests();
    this.loading = false;
    this.pools = data;
    this.locations = meta.locations;

    /* const $this = this;
    this.$el.addEventListener('checkformodals', () => {
      $this.checkForModals($this);
    }, true);

    this.checkForModals(); */
  },
  methods: {
    ...mapMutations([
      'increaseCurrentRequests',
      'decreaseCurrentRequests',
      'currentRequests',
      'changeFreeSearch',
      'openModal',
      'resetAccomodationsFilter',
    ]),
    showModal() {
      return this.$route.params.pool;
    },
    checkForModals($this) {
      if (!$this.$route) {
        return;
      }
      if ($this.$route.name === 'accomodation price') {
        $this.openModal(['UnitPriceModal', {
          pool_lid: $this.$route.params.poolId,
          unit_lid: $this.$route.params.unitId,
        }]);
      }
      if ($this.$route.name === 'accomodation info' || $this.$route.name === 'accomodation info with price') {
        if ($this.$route.name === 'accomodation info with price') {
          $this.openModal(['UnitInfoModal', {
            pool_lid: $this.$route.params.poolId,
            unit_lid: $this.$route.params.unitId,
            arrival: $this.$route.params.arrival,
            departure: $this.$route.params.departure,
          }]);
        } else {
          $this.openModal(['UnitInfoModal', {
            pool_lid: $this.$route.params.poolId,
            unit_lid: $this.$route.params.unitId,
          }]);
        }
      }
    },
    goToNormal() {
      this.$store.state.accomodationView = '';
    },
  },
  computed: {
    ...mapGetters([
      'getFreeSearch',
      'isAwaitingFilter',
    ]),
    filteredPools() {
      return filterPools(this.$store.state.accomodationsFilter)(this.pools);
    },
    unitCount() {
      const unitFilter = filterUnit(this.$store.state.accomodationsFilter);
      return sumBy(
        pool => filter(unitFilter, pool.units).length,
        this.filteredPools,
      );
    },
    poolCount() {
      return this.filteredPools.length;
    },
  },
};
</script>

<style lang="stylus">
@import '~@/global.styl'

.notification
  margin 0 auto
  margin-bottom: 20px
  max-width container-width

.waiting-for-filter
  disabled-grey()

.freesearch-header
  max-width container-width
  margin-right auto
  margin-left auto
  position relative
  .narrow
    max-width 600px
    margin-right auto
    margin-left auto
  button
    position absolute
    top 0
    left 0
    +max-mobile()
      position: relative;
      margin-bottom: 10px
      margin-left: auto;
      margin-right: auto;
      display: block;

h1
  margin-bottom 20px

body
  background-color white

.cancellation-insurance-notice
  ul
    display flex
    flex-wrap wrap
    margin-top 8px
    padding-left 15px
    justify-content center
    +max-mobile()
      text-align left !important
    li
      margin-right 20px
      +max-mobile()
        width 100%
</style>



// WEBPACK FOOTER //
// AccomodationsPage.vue?188c6bc7